import { useEffect, useState } from 'react'

export const useScrollbarBehavior = () => {
  const [justScrolled, setJustScrolled] = useState<any>(null)

  useEffect(() => {
    if (justScrolled) {
      document.body.setAttribute('data-scrollbar-visible', 'true')
    } else {
      document.body.removeAttribute('data-scrollbar-visible')
    }
  }, [justScrolled])

  const onScroll = () => {
    if (justScrolled) {
      clearTimeout(justScrolled)
    }

    setJustScrolled(
      setTimeout(() => {
        setJustScrolled(false)
      }, 1000),
    )
  }

  return { onScroll }
}
